/* eslint-disable no-debugger */
import Constants from '@usas/ui-web/utils/Constants';
import ToIntIfInt from '@usas/ui-web/utils/ToIntIfInt';
import { ageRangeErrors } from '../kendoReports/shared/ReportFilterValidation';

export const localValidate = (formState) => {
  let errors = { ...ageRangeErrors(formState) };

  if (formState.seasonId < 0 && formState.startDate === Constants.BLANK_DATE_STRING ) {
    errors.seasonId = 'Select a Season Year or enter a Start Date / End Date';
  }

  if (formState.startDate !== Constants.BLANK_DATE_STRING && formState.endDate === Constants.BLANK_DATE_STRING) {
    errors.endDate = 'End Date is required if Start Date is entered';
  }

  if (formState.endDate !== Constants.BLANK_DATE_STRING && formState.startDate === Constants.BLANK_DATE_STRING) {
    errors.startDate = 'Start Date is required if End Date is entered';
  }

  if (formState.startDate !== Constants.BLANK_DATE_STRING && formState.endDate !== Constants.BLANK_DATE_STRING) {
    if (new Date(formState.startDate) > new Date(formState.endDate)) {
      errors.startDate = 'Start Date cannot be after End Date';
      errors.endDate = 'End Date cannot be before Start Date';
    }
  }

  if (formState.seasonId > 0 && formState.startDate !== Constants.BLANK_DATE_STRING) {
    errors.startDate = 'Cannot enter both a Season Year and a Start Date / End Date';
  }

  const topTimes = ToIntIfInt(formState.topTimes);

  if (formState.topTimes === '') {
    errors.topTimes = 'Top Times is required';
  } else if (typeof topTimes !== 'number') {
    errors.topTimes = 'Top Times must be a whole number';
  } else if (topTimes < 1 || topTimes > 100) {
    errors.topTimes = 'Top Times must be between 1 and 100';
  }

  if (formState.genders.length === 0) {
    errors.genders = 'At least one competition category must be selected';
  }

  if (formState.minTimeStandard < formState.maxTimeStandard) {
    errors.minTimeStandard = 'Min Time Standard cannot be faster than Max Time Standard';
  }

  const minPowerPoints = ToIntIfInt(formState.minPowerPoints);

  if (formState.minPowerPoints === '') {
    errors.minPowerPoints = 'Min Power Points is required';
  } else if (typeof minPowerPoints !== 'number') {
    errors.minPowerPoints = 'Min Power Points must be a whole number';
  } else if (minPowerPoints < 0) {
    errors.minPowerPoints = 'Min Power Points cannot be negative';
  }

  return errors;
};

const TimesDetailKendoReportValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default TimesDetailKendoReportValidation;